import { themeAtom } from "Infrastructure/Theme/Atom/themeAtom";
import { DarkMode, LightMode } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useAtom } from "jotai";

export function ThemeSwitch() {
	const [themeConfiguration, setThemeConfiguration] = useAtom(themeAtom);

	if (themeConfiguration.activeMode === "light") {
		return (
			<IconButton
				size="small"
				color="secondary"
				onClick={() =>
					setThemeConfiguration({
						...themeConfiguration,
						activeMode: "dark",
					})
				}
			>
				<DarkMode fontSize="small" />
			</IconButton>
		);
	}

	return (
		<IconButton
			size="small"
			color="secondary"
			onClick={() =>
				setThemeConfiguration({
					...themeConfiguration,
					activeMode: "light",
				})
			}
		>
			<LightMode fontSize="small" />
		</IconButton>
	);
}
